import { render, staticRenderFns } from "./QuestionsDetail.vue?vue&type=template&id=efa3faae"
import script from "./QuestionsDetail.vue?vue&type=script&lang=ts"
export * from "./QuestionsDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports